module.exports = __webpack_public_path__ + "img/evaluate_thumbnail_001.31006117.png";